module.exports = __webpack_public_path__ + "common/sidebar/icon-bank-fe56c55bb84e56fda20bc9270c49b555.svg";